import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { User } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const FAQ: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      console.log('Current user ID:', user.id);
    }
  }, [user]);

  const faqs = [
    {
      question: 'How realistic is the hair loss preview?',
      answer: 'WhenBald uses state-of-the-art AI to generate highly realistic hair loss progression images based on your photo and genetic factors. Results are for guidance only—always consult a healthcare professional for hair loss treatment decisions.',
    },
    {
      question: 'Will my photo be saved or shared?',
      answer: 'Your privacy matters. Photos are processed securely and never shared or used for any other purpose. Please see our Privacy Policy for details.',
    },
    {
      question: 'What kinds of photos work best?',
      answer: 'Clear headshots or selfies in good lighting work best. Make sure only you are in the photo and your hairline is clearly visible for the most accurate preview.',
    },
    {
      question: 'Is WhenBald free to use?',
      answer: '100% free to use!',
    },
  ];

  return (
    <div className="container mx-auto px-4 py-16">
      <h1 className="text-4xl font-bold text-center mb-12">Frequently Asked Questions</h1>
      <div className="max-w-3xl mx-auto space-y-6">
        {faqs.map((faq, index) => (
          <div key={index} className="bg-white rounded-lg shadow-sm p-6">
            <h3 className="text-xl font-semibold mb-2">{faq.question}</h3>
            <p className="text-gray-600">{faq.answer}</p>
          </div>
        ))}

        <div className="mt-12 bg-gradient-to-r from-primary-50 to-white p-8 rounded-2xl shadow-sm">
          <div className="text-center">
            <h2 className="text-2xl font-semibold mb-4">Ready to see your transformation?</h2>
            <p className="text-gray-600 mb-6">
              Upload your photo and get your personalized hair loss preview in minutes.
            </p>
            <button
              onClick={() => navigate('/start')}
              className="bg-primary-600 text-white px-8 py-4 rounded-xl hover:bg-primary-700 transition-all transform hover:scale-105 inline-flex items-center gap-2"
            >
              <User size={20} />
              Try WhenBald Free
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
